import {useEffect, useState} from 'react'
import {Actualizar, GetOrder, ActualizarManoDeObra} from './dbfirebase'
import { useMatch, useNavigate } from 'react-router-dom';
import { useAuth } from "../context/authcontext";
import { useSelector } from 'react-redux';
import {
    calculateFinalizedRepairLabor,
    normalizeManoDeObra,
    validateRepairCompletion,
} from '../utils/manoDeObra';
import { getRepairDetails, requiresRepairDetails as hasRepairDetails } from '../utils/repairDetails';

export const ModalFinalizado = () => {

    const match = useMatch('/ordenes/finalizado/:id')
    const id = match.params.id
    const navigate = useNavigate();
    const {user} = useAuth();
    const [motivo, setMotivo] = useState()
    const [selectedOperations, setSelectedOperations] = useState({});
    const orders = useSelector(state => state.ordersInfo)
    const ManoDeObraData = useSelector(state => state.manodeobra)
    const [mdo, setMdo] = useState(0)
    const [kilometros, setKilometros] = useState('');
    const [noAplica, setNoAplica] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [showKmWarning, setShowKmWarning] = useState(false);
    const [kmWarningDismissed, setKmWarningDismissed] = useState(false);
    const KM_WARNING_THRESHOLD = 200;

    const order = orders.filter((f) => f.Id === id)
    
    const repairDetails = getRepairDetails(order[0]?.Tipo);
    const requiresRepairDetails = hasRepairDetails(order[0]?.Tipo);
    const laborConfiguration = Array.isArray(mdo) ? mdo[0] : null;
    
    const dataId = async () =>{
        const errors = validateRepairCompletion({
            requiresRepairDetails,
            kilometers: kilometros,
            noAplica,
            operations: selectedOperations,
            motivo,
        });
        if (errors.length > 0) {
            setValidationErrors(errors);
            return;
        }

        const kmDesplazados = noAplica ? 0 : kilometros;
        const finalizedLaborCost = requiresRepairDetails
            ? calculateFinalizedRepairLabor(
                order[0]?.ManoDeObra,
                selectedOperations,
                laborConfiguration,
                kmDesplazados,
            )
            : normalizeManoDeObra(order[0]?.ManoDeObra);
        await Actualizar('Reparado', {Fecha_finalizado: new Date().toLocaleString(), usuario: user.email}, motivo, id);
        await ActualizarManoDeObra(finalizedLaborCost, selectedOperations, kmDesplazados, id);
        navigate('/ordenes');
    }

    const costomasreciente = (data, subcategoria, fecha) => {
        // const fechaActual = Math.floor(new Date().getTime() / 1000);
        const fechaActual = fecha
        let fechaMasCercana = Number.MAX_SAFE_INTEGER;
        let valoresCampoMasCercano = null;
        let diferencias = {};
        try {
            data.forEach((obj) => {
                // Suponiendo que `obj` es el objeto con las fechas como claves
                // let diferencias = {};
                Object.keys(obj).forEach((clave) => {
                    
                    if (clave !== 'Fecha') {
                        const [dia, mes, anio] = clave.split(/[/\-]/) //clave.split('/'); // Modificar para usar - tambien
                        const fechaEnSegundos = new Date(anio, mes - 1, dia).getTime() / 1000;
                        if(fechaEnSegundos < fechaActual){
                            
                            const diferenciaAbsoluta = Math.abs(fechaActual - fechaEnSegundos);
                            diferencias[clave] = diferenciaAbsoluta;
                            // Encontrar la clave con la menor diferencia absoluta
                            let claveMasCercana = diferencias?Object.keys(diferencias).reduce((a, b) => diferencias[a] < diferencias[b] ? a : b):""
                            valoresCampoMasCercano = obj[claveMasCercana];
                            
                        }
                    }
                });
            });
            setMdo(valoresCampoMasCercano)
            
            return valoresCampoMasCercano;
        } catch (error) {
            console.log(error);
            return null;
        }
    };

    useEffect(() => {
        if (order[0]) {
            costomasreciente(ManoDeObraData, order[0].Tipo, order[0].TimeStamp);
        }
    },[ManoDeObraData, order[0]?.Tipo, order[0]?.TimeStamp])

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        setSelectedOperations(prevState => {
            const newState = { ...prevState, [value]: checked };
            return newState;
        });
        
    };
    
    
    const handleKilometrosChange = (event) => {
        const value = event.target.value;
        setKilometros(value);

        const numericKm = Number(value);
        if (value !== '' && Number.isFinite(numericKm) && numericKm >= KM_WARNING_THRESHOLD) {
            if (!kmWarningDismissed) {
                setShowKmWarning(true);
            }
        } else {
            setShowKmWarning(false);
            setKmWarningDismissed(false);
        }
    };

    const handleNoAplicaChange = (event) => {
        const checked = event.target.checked;
        setNoAplica(checked);
        if (checked) {
            setKilometros('');
            setShowKmWarning(false);
        }
    };

    const renderKilometrosField = () => (
        <>
            <label>
                Ingrese excedente $ / km (a partir de los 15 km desde el taller, considerar IDA + VUELTA):
            </label>
            <input
                type="number"
                value={kilometros}
                onChange={handleKilometrosChange}
                placeholder="Ingrese valor"
                disabled={noAplica}
                min="0"
            />
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id="noAplicaKilometros"
                    checked={noAplica}
                    onChange={handleNoAplicaChange}
                />
                <label className="form-check-label" htmlFor="noAplicaKilometros">
                    No aplica (0 km)
                </label>
            </div>
        </>
    );

    const handleCloseKmWarning = () => {
        setShowKmWarning(false);
        setKmWarningDismissed(true);
    };
    
    return (
        <>
            <div>
                {/* <div style={{ overflow: "auto", height: '23rem' }}> */}
                    <h2>Orden de servicio</h2>

                    <div className="col-12 d-flex flex-column" style={{ marginBottom: '20px'}}>
                        {repairDetails ? (
                            <>
                                <h4 style={{ marginBottom: '20px'}}>Operaciones adicionales</h4>
                                {repairDetails.operations.map(({ key, label }) => (
                                    <div className="form-check" key={key}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="operation"
                                            value={key}
                                            checked={selectedOperations[key] || false}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label className="form-check-label">{label}</label>
                                    </div>
                                ))}
                                {renderKilometrosField()}
                            </>
                        ) : null}
                        <div className="form-check" style={{ marginTop: '20px'}}>
                        {mdo === 0 && !requiresRepairDetails ?
                            <>
                                <input className="form-check-input" type="checkbox" name="operation" value="Canje" 
                                    checked={selectedOperations.Canje || false}
                                    onChange={handleCheckboxChange}/>
                                <label className="form-check-label" > 
                                    Gestión de canje
                                </label>
                            </>
                            :<></>}
                        </div>
                        
                       
                    </div>

                    {/* Textarea for additional details */}
                    <p>Especificar brevemente qué operación de reparación se aplicó</p>
                    <div className='col-12 d-flex justify-content-center'>
                        <textarea rows='5' style={{ marginTop: '20px', width: '100%' }} name='motivo' value={motivo || ''} onChange={(event) => setMotivo(event.target.value)} />
                    </div>  
                    {validationErrors.length > 0 ? (
                        <div className="alert alert-danger" role="alert">
                            <strong>No se pudo confirmar la orden:</strong>
                            <ul className="mb-0">
                                {validationErrors.map((error) => <li key={error}>{error}</li>)}
                            </ul>
                        </div>
                    ) : null}
                    
                    {/* Confirmation button */}
                    <div className='col-12 d-flex justify-content-end'>    
                        <button className="btn btn-secondary" style={{ height: '3rem', width: '7rem', marginTop: '20px' }} onClick={() => { dataId() }}>
                            Confirmar
                        </button>
                    </div>
        </div>

        {showKmWarning ? (
            <>
                <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Advertencia</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseKmWarning}></button>
                            </div>
                            <div className="modal-body">
                                <p>Ingresó {KM_WARNING_THRESHOLD} km o mas. Por favor verifique el dato si es correcto antes de confirmar.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseKmWarning}>
                                    Entendido
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show"></div>
            </>
        ) : null}
       
        </>
    );
};
